import { EApiUpstream } from '@enums';

import { Log } from '@utils';

import {
	IFetchNotAppFriendsParams,
	IInviteNotAppFriendsParams,
	IMakeStreamPostParams,
	IFetchNotAppFriendsResponse,
	IFetchInvitationResponse,
} from '@api';

import { BaseApi } from '../BaseApi';
import { getRESTAPIUrl } from './utils';

import { IApiBaseRequestParams } from '@interfaces';

export class RESTApi extends BaseApi {

	async fetchNotAppFriends(
		params: IFetchNotAppFriendsParams,
		privateKey: string,
	): Promise<IFetchNotAppFriendsResponse> {
		const url = getRESTAPIUrl(params, {
			method: 'friends.getNotAppUsers',
			offset: params.offset || 0,
			limit: params.limit || 100,
		}, privateKey);

		try {
			const resp = await this.get({
				url,
				upstream: EApiUpstream.MPOP,
			});
			return resp.data as IFetchNotAppFriendsResponse;
		} catch (err) {
			Log.error(`Couldn't get not app users: ${err}`);
		}
	}

	async inviteNotAppFriends(
		params: IInviteNotAppFriendsParams,
		privateKey: string,
	): Promise<number> {
		const url = getRESTAPIUrl(params, {
			method: 'friends.invite',
			mna: params.mna,
			mnb: params.mnb,
			uids: params.uids,
			target: 'mobile',
		}, privateKey);

		try {
			const res = await this.get<IApiBaseRequestParams, IFetchInvitationResponse>({
				url,
				upstream: EApiUpstream.MPOP,
			});
			return res.data.result;
		} catch (err) {
			Log.error(`Couldn't invite not app users: ${err}`);
		}
	}

	async makeStreamPost(
		params: IMakeStreamPostParams,
		privateKey: string,
	) {
		const url = getRESTAPIUrl(params, {
			/* eslint-disable @typescript-eslint/naming-convention */
			method: 'stream.post',
			vid: params.vid,
			img_url: params.img_url,
			title: params.title,
			text: params.text,
			/* eslint-enable @typescript-eslint/naming-convention */
		}, privateKey);

		try {
			await this.get({
				url,
				upstream: EApiUpstream.MPOP,
			});
		} catch (err) {
			Log.error(`Couldn't make stream post: ${err}`);
		}
	}

}
